//import logo from "./logo.svg";
import React from "react";
import { useEffect } from "react";
import "./App.css";
//import ContactForm from "./ContactForm";
//import Form from "./Form"
//import ExampleTable  from "./Table";
//import "./styles.css";

//import LayoutForm from "./LayoutForm"
import ContactForm from './NewForm'


function App() {
  // You can skip useEffect if you're not using TailwindCSS
  // Otherwise, for the production usage refer to https://tailwindcss.com/docs/installation
  useEffect(() => {
    if (document) {
      const stylesheet = document.createElement("link");
      stylesheet.rel = "stylesheet";
      stylesheet.href = "https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css";

      document.head.appendChild(stylesheet);
    }
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        {/*<img src={logo} className="App-logo" alt="logo" />*/}
        <div className="py-6">
          <ContactForm />
        </div>
      </header>
    </div>
  );
}

export default App;